import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import {
  getTopicDetail,
  updateTopic,
  clearErrors,
} from "../../../actions/adminTopicActions";
import { UPDATE_TOPIC_RESET } from "./../../../constants/adminTopicConstants";

import Loader from "../../Loader";

import "./Topic.css";

const EditTopic = ({ history, match }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [topicId, setTopicId] = useState("");
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState(false);

  const [errorData, setErrorData] = useState({});

  const { isUpdated, user_loading, error, errors } = useSelector(
    (state) => state.topics
  );

  const currentId = match.params.id;
  const subjectId = match.params.subjectId;
  useEffect(() => {
    dispatch(getTopicDetail(subjectId, currentId));
  }, [dispatch]);

  const { topic } = useSelector((state) => state.topicDetail);

  useEffect(() => {
    if (errors) {
      setErrorData(errors);
    }

    if (topic) {
      setTopicId(topic._id);
      setTitle(topic.title);
      setStatus(topic.status);
    }
    if (error) {
      alert.error(error);
      dispatch(clearErrors());
    }
    if (isUpdated) {
      alert.success("Topic updated successfully");
      dispatch(getTopicDetail(topic._id));
      history.push(`/admin/topics/${subjectId}`);
      dispatch({
        type: UPDATE_TOPIC_RESET,
      });
    }
  }, [dispatch, topic, alert, error, errors, history, isUpdated]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(updateTopic(topicId, subjectId, title, status));
  };

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Edit
                <small>Topic</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/admin/subjects`}>
                    <i className="fa fa-table"></i> Subjects
                  </Link>
                </li>
                <li>
                  <Link to={`/admin/topics/${subjectId}`}>
                    <i className="fa fa-table"></i> Topics
                  </Link>
                </li>
                <li className="active">Edit Topic</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Edit Topic</h3>

                  {/*<div className="box-tools pull-right">

                                    </div>*/}
                </div>

                <form
                  id="quickForm"
                  onSubmit={submitHandler}
                  encType="multipart/form-data"
                >
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="title">Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          id="title"
                          placeholder="Enter Title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                        {errorData.title ? (
                          <span className="text-danger">{errorData.title}</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="status">Status </label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          checked={status}
                          value={status}
                          onChange={(e) => setStatus(!status)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EditTopic;
